import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface NPSPropsType {
  score: number | undefined;
}
const NPS = ({ score }: NPSPropsType) => {
  const t = useFormatMessage();

  return (
    <Wrapper>
      <Typography fontSize={'3rem'} fontWeight={500} color={'#1656e9'}>
        {score}
      </Typography>
      <Typography
        fontSize={'0.875rem'}
        fontWeight={400}
        color={'#253858'}
        textAlign={'center'}
      >
        {t('reports.nps', 'Net Promoter Score')}
      </Typography>
    </Wrapper>
  );
};

export default NPS;
